import { CAST_AI } from '@cast/constants';

import {
  ControlWithDescription,
  InlineWithDescription,
} from 'components/form-layouts';

import { InputsStack, RffInput, RemoveInputs } from '@cast/shared-rff-ui';

import { Box } from '@cast/design-system';

export const TagsSection = () => (
  <InlineWithDescription
    description={
      <ControlWithDescription label="Instance tags">
        Set up tags to be applied to every {CAST_AI} provisioned node.
      </ControlWithDescription>
    }
    controls={
      <InputsStack
        name="tags"
        addRowButtonTestId="add-tag-button"
        renderInputsRow={({ index }) => {
          return (
            <Box display="grid" gridTemplateColumns="1fr 1fr" gap={8}>
              <RffInput
                testId={`tag-key-input-${index}`}
                name={`tags[${index}].key`}
                label="Key"
                placeholder="e.g. environment"
              />
              <RffInput
                testId={`tag-value-input-${index}`}
                name={`tags[${index}].value`}
                label="Value"
                placeholder="e.g. production"
                endOutsideAdornment={<RemoveInputs />}
              />
            </Box>
          );
        }}
      />
    }
  />
);
